import { put, call, take, fork } from 'redux-saga/effects'
import { LLMCheckAttachmentStatusService } from '../../api/llm'
import { llmCheckAttachmentStatusSuccess } from '../../reducers/llm/action'
import { CHECK_ATTACHMENT_STATUS } from '../../reducers/llm/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* checkAttachmentStatusFlow(payload) {
  try {
    const { chatId, attachmentId, callback } = payload

    const response = yield call(
      LLMCheckAttachmentStatusService,
      chatId,
      attachmentId,
    )
    yield put(llmCheckAttachmentStatusSuccess(response))
    yield put(operationSuccess())
    callback(response)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* checkAttachmentStatusWatcher() {
  while (true) {
    const action = yield take(CHECK_ATTACHMENT_STATUS)
    const { payload } = action

    yield fork(generalSaga, checkAttachmentStatusFlow, payload, false)
  }
}
